/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_0_2Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_0_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_0_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietary. A free web edition exists; desktop access depends on the license or plan.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_0_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_0_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专有软件。有免费网页版；桌面版使用权限取决于许可或方案。`)
};

/**
* | output |
* | --- |
* | "Proprietary. A free web edition exists; desktop access depends on the license or plan." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_0_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_0_2 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_0_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_0_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_0_2(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_0_2(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_0_2 as "gc.search_guides.gridcraft_vs_excel.sections.0.table.rows.0.2" }